import { AxiosInstance, AxiosRequestConfig } from "axios";

const originalStackTraceKey = "topMostError";
export const enhancedAxiosErrorTitle = "[EnhancedAxiosError]";

function enhanceAxiosStack(axiosInstance: AxiosInstance) {
  const originalGetHandler = axiosInstance.get;
  const originalPostHandler = axiosInstance.post;
  const originalPutHandler = axiosInstance.put;
  const originalPatchHandler = axiosInstance.patch;

  axiosInstance.get = function (url, config) {
    const newConfig = {
      ...config,
      [originalStackTraceKey]: new Error(enhancedAxiosErrorTitle),
    } as unknown as AxiosRequestConfig;

    return originalGetHandler(url, newConfig);
  };

  axiosInstance.post = function (url, data, config) {
    const newConfig = {
      ...config,
      [originalStackTraceKey]: new Error(enhancedAxiosErrorTitle),
    } as unknown as AxiosRequestConfig;

    return originalPostHandler(url, data, newConfig);
  };

  axiosInstance.put = function (url, data, config) {
    const newConfig = {
      ...config,
      [originalStackTraceKey]: new Error(enhancedAxiosErrorTitle),
    } as unknown as AxiosRequestConfig;

    return originalPutHandler(url, data, newConfig);
  };

  axiosInstance.patch = function (url, data, config) {
    const newConfig = {
      ...config,
      [originalStackTraceKey]: new Error(enhancedAxiosErrorTitle),
    } as unknown as AxiosRequestConfig;

    return originalPatchHandler(url, data, newConfig);
  };
}

export default enhanceAxiosStack;
